import { WindowTitle } from "@saleor/components/WindowTitle";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";

import AnnouncementCreatePage from "../components/AnnouncementCreatePage";
import { TypedAnnouncementCreate } from "../mutations";
import { AnnouncementCreate } from "../types/AnnouncementCreate";
import { announcementListUrl, announcementUrl } from "../urls";

export const AnnouncementCreateView: React.FC = () => {
  const intl = useIntl();
  const navigate = useNavigator();
  const notify = useNotifier();

  const handleAnnouncementCreate = (data: AnnouncementCreate) => {
    if (data.announcementCreate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Successfully created announcement"
        })
      });
      navigate(announcementUrl(data.announcementCreate.announcement.id), true);
    } else {
      notify({
        status: "error",
        text: data.announcementCreate.errors[0].message
      });
    }
  };

  return (
    <TypedAnnouncementCreate onCompleted={handleAnnouncementCreate}>
      {(AnnouncementCreate, AnnouncementOpts) => (
        <>
          <WindowTitle title={intl.formatMessage(sectionNames.announcements)} />
          <AnnouncementCreatePage
            errors={AnnouncementOpts.data?.announcementCreate.errors || []}
            onBack={() => navigate(announcementListUrl())}
            disabled={AnnouncementOpts.loading}
            saveButtonBarState={AnnouncementOpts.status}
            onSubmit={(formData, file) => {
              AnnouncementCreate({
                variables: {
                  input: {
                    content: JSON.stringify(formData.content),
                    endDate: `${formData.endDate}T00:00:00+00:00`,
                    image: file || null,
                    startDate: `${formData.startDate}T00:00:00+00:00`,
                    title: formData.title
                  }
                }
              });
            }}
          />
        </>
      )}
    </TypedAnnouncementCreate>
  );
};

export default AnnouncementCreateView;
